import { lazy } from 'react'

import { authRoles } from '../../../../../auth/authRoles'
import Loadable from '../../../../base/components/Template/Loadable/Loadable'

const CafcApp = Loadable(lazy(() => import('./view/Cafc')))

export const cafcRoutesMap = {
  gestion: {
    path: '/cafc',
    name: 'Código CAFC',
  },
}

const CafcRoutes = [
  {
    path: cafcRoutesMap.gestion.path,
    element: <CafcApp />,
    auth: authRoles.admin,
  },
]

export default CafcRoutes
